
export default {
  reports: [],
  searchParameters: {},
  dateRange: {},
  selectFormVesselNameProps: null,
  selectedVesselNames: [],
  selectFormSenderProps: null,
  selectedSenders: [],
  selectFormStatusProps: null,
  selectedStatus: [],
  statusColorMapping: null,
  paginationPageSize: 100, //100固定
  currentPage: 0,
  totalReportCount: 0,
  totalPage: 0,
};
